import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Stack from "@mui/material/Stack";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {useLocation, useNavigate} from "react-router-dom";
import firebase from "../../firebase/firebase";
import ManageProjectNda from "./manage-project-nda";
import ManageProjectContracts from "./manage-projects-contract";
import ManageProjectsMilestones from "./manage-projects-milestones";
import Button from "@mui/material/Button";
import ManageProjectsDeadlines from "./manage.projects-deadlines";
import ManageProjectPayments from "./manage-project-payments";
import PaymentDetails from "./payment-details";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import Portal from "@mui/material/Portal";


const AntTabs = styled(Tabs)({
  borderBottom: '1px solid #e8e8e8',
  '& .MuiTabs-indicator': {
    backgroundColor:  '#204488',
  },

});

const AntTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
  textTransform: 'none',
  minWidth: 0,
  [theme.breakpoints.up('sm')]: {
    minWidth: 0,
  },
  fontWeight: theme.typography.fontWeightRegular,
  marginRight: theme.spacing(1),
  fontSize: '18px',
  color: 'rgba(0, 0, 0, 0.85)',

  '&:hover': {
    color: '#204488',
    opacity: 1,
  },
  '&.Mui-selected': {
    color: '#204488',
    fontWeight: theme.typography.fontWeightBold,
  },
  '&.Mui-focusVisible': {
    backgroundColor: '#d1eaff',
  },
}));

export default function ProjectManagement(){
  const navigator = useNavigate();
  const location = useLocation()
  const {project, tab} = location.state;
  const [value, setValue] = React.useState(tab ? tab : 0);
  const [ndaList, setNdaList] = React.useState([]);
  const [contracts, setContracts] = React.useState([]);
  const [payments, setPayments] = React.useState([]);
  const [details, setDetails] = React.useState(false)
  const [receipt, setReceipt] = React.useState()
  const [open, setOpen] = React.useState(false);
  const [removeAdminLoading,setLoadingRemove] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleChange = (event, newValue) => {

    setValue(newValue);
  };

  const projectRoomRemove = () => new Promise(async (resolve, reject) => {
    try {
      const roomDocs = await firebase
        .firestore().collection('rooms').orderBy('createdAt', "desc")
        .where('projectId', '==', project?.id)
        .get()
      if (roomDocs.size > 0) {
        for (let room of roomDocs.docs){
          await firebase
            .firestore()
            .collection('rooms')
            .doc(room?.id)
            .delete();
        }
      }
      resolve(true)
    } catch (e) {
      reject(e)
    }
  })
  const projectNotificationsRemove = () => new Promise(async (resolve, reject) => {
    try {
      const roomDocs = await firebase
        .firestore().collection('notifications').orderBy('createdAt', "desc")
        .where('projectId', '==', project?.id)
        .get()
      if (roomDocs.size > 0) {
        for (let room of roomDocs.docs){
          await firebase
            .firestore()
            .collection('notifications')
            .doc(room?.id)
            .delete();
        }
      }
      resolve(true)
    } catch (e) {
      reject(e)
    }
  })
  const removeProject = async () => {
    setLoadingRemove(true)
    try{
      await projectRoomRemove()
      await projectNotificationsRemove()
      await firebase
        .firestore()
        .collection('projects')
        .doc(project?.id)
        .delete();
      setLoadingRemove(false)

      navigator('/admin/project-live')
    } catch (e) {
      setLoadingRemove(false)

    } finally {
      handleClose()
    }
  }

  const loadNda = async () => {

    const nda = await firebase
      .firestore()
      .collection('NDA')
      .orderBy('createdAt', 'desc')
      .where('projectId', '==', project?.id)
      .get()

    if (nda?.size > 0) {
      const list = nda.docs?.map((n) => ({id: n.id, ...n.data()}))
      setNdaList(list)
    } else {
      setNdaList([]);
    }

    console.log(`Projects NDA ${nda?.size}`)

  }
  const loadContracts = async () => {

    const contracts = await firebase
      .firestore()
      .collection('contracts')
      .orderBy('createdAt', 'desc')
      .where('projectId', '==', project?.id)
      .get()

    if (contracts?.size > 0) {
      const list = contracts.docs?.map((n) => ({id: n.id, ...n.data()}))
      setContracts(list)
    } else {
      setContracts([]);
    }

    console.log(`Projects NDA ${contracts?.size}`)

  }

  const loadPayment = async () =>{
    const receipts = await firebase
      .firestore()
      .collection('receipts')
      .orderBy('createdAt', "desc")
      .where('projectId', '==', project?.id)
      .get()
    if (receipts?.size > 0) {
      const list = receipts.docs?.map((n) => ({id: n.id, ...n.data()}))
      setPayments(list)
    } else {
      setPayments([]);
    }
    // receipts
  }
  React.useEffect(() => {
    loadNda()
    loadContracts()
    loadPayment()
  },[])
  if(receipt) return (
    <PaymentDetails payment={receipt} callback={(bool) => setReceipt(undefined)}/>
  )
  if (details) return (
    <Container maxWidth={'full-width'}  sx={{height: 'calc(100vh - 120px)', p: 5, textAlign: 'left', overflowY: 'scroll'}}>
    <Stack direction={'column'} spacing={5} >
      <Typography variant={'h5'} color={'primary'}>
        Payment details
      </Typography>
      <Stack direction={'row'} spacing={3}>
        <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
          Country
        </Typography>
        <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
          {project?.contract?.bankDetails?.country}
        </Typography>
      </Stack>
      <Stack direction={'row'} spacing={3}>
        <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
          Bank name
        </Typography>

        <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
          {project?.contract?.bankDetails?.bankName}
        </Typography>
      </Stack>
      <Stack direction={'row'} spacing={3}>
        <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
          Account title
        </Typography>

        <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
          {project?.contract?.bankDetails?.accountTitle}
        </Typography>
      </Stack>
      <Stack direction={'row'} spacing={3}>
        <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
          Recipient’s full name
        </Typography>
        <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
          {project?.contract?.bankDetails?.recipientName}
        </Typography>
      </Stack>
      <Stack direction={'row'} spacing={3}>
        <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
          Recipient’s address
        </Typography>

        <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
          {project?.contract?.bankDetails?.recipientAddress}
        </Typography>
      </Stack>
      <Stack direction={'row'} spacing={3}>
        <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
          Account Number
        </Typography>

        <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
          {project?.contract?.bankDetails?.accountNumber}
        </Typography>
      </Stack>
      <Stack direction={'row'} spacing={3}>
        <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
          BIC/SWIFT Code
        </Typography>
        <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300}} noWrap={true}>
          {project?.contract?.bankDetails?.swiftCode}
        </Typography>
      </Stack>
      <Stack direction={'row'} spacing={3} justifyContent="center"
             alignItems="center">
        <Button variant={'contained'} color={'primary'} onClick={() => setDetails(!details)}>Go back</Button>

      </Stack>
    </Stack>
    </Container>
  )
  return (
    <>
    <Container maxWidth={'full-width'}  sx={{height: 'calc(100vh - 120px)', p: 5, textAlign: 'left',  overflowY: 'scroll'}}>

      <Stack direction={'column'} spacing={5}>
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'h4'} sx={{textTransform: 'capitalize'}} color={'primary'}>
            {project.title} > Management
          </Typography>
        </Stack>
        
        <Box >

          <AntTabs value={value} variant={'fullWidth'} onChange={handleChange} aria-label="ant example">
            <AntTab label="Nda" />
            <AntTab label="Contracts" />
            <AntTab label="Payments" />
            <AntTab label="Milestones" />
            <AntTab label="Deadlines" />
          </AntTabs>
          <Box sx={{ p: 3 }} >
            {value === 0 && <ManageProjectNda ndaList={ndaList} project={project}/>}
            {value === 1 && <ManageProjectContracts contarctList={contracts} project={project} />}
            {value === 2 && <ManageProjectPayments payments={payments} callback={(payment) => setReceipt(payment) } />}
            {value === 3 && <ManageProjectsMilestones payments={payments} project={project} projectId={{projectId:project?.id,contract: project.contract }} milestone={project && project?.contract && project?.contract?.millstones ? project?.contract?.millstones : null}
                                                      parentCallback={(bool) => setDetails(bool) }/>}
            {value === 4 && <ManageProjectsDeadlines contracts={contracts} project={project} receipts={payments} />}
            
          </Box>
        </Box>
          <Stack direction="row" justifyContent="center" spacing={5}>
        
          <Button onClick={() => navigator('/admin/project-live')} sx={{width:"180px",height:"50px"}}
           color={'primary'} variant={'contained'}>Go back</Button>
          <Button onClick={handleClickOpen} sx={{width:"200px",height:"50px"}}
           color={'warning'} variant={'contained'}>Remove project</Button>
          </Stack>
      </Stack>
    </Container>

      <Portal>
        <div>

          <Dialog
            open={open}
            onClose={handleClose}
            fullWidth={true}
            maxWidth={'sm'}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title" color={'primary'}>
              Before you move forward...
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                This action will permanently remove the project.
                Do you want to proceed with this action?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Go back</Button>
              <Button onClick={removeProject} variant={'contained'} color={'warning'} size={'small'} sx={{px: 3}} endIcon={removeAdminLoading ? <CircularProgress size={20}/> : '' } disabled={removeAdminLoading}>
                Remove project
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Portal>
</>
  )
}
